import { render, staticRenderFns } from "./SchemaFormDialog.vue?vue&type=template&id=5b0e4ccc&"
import script from "./SchemaFormDialog.vue?vue&type=script&lang=js&"
export * from "./SchemaFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports